import React from 'react';

import {
  Box, Table, TagChip, Typography,
} from 'vindi-ds-components';

import getPropsTagChipOverdue from '../utils/get_props_tag_chip_overdue';
import getPropsTagChipStatus from '../utils/get_props_tag_chip_status';

const columns = [
  {
    label: 'Cadastro',
    align: 'left',
  },
  {
    label: 'Término',
    align: 'left',
  },
  {
    label: 'Nome',
    align: 'left',
  },
  {
    label: 'Plano',
    align: 'left',
  },
  {
    label: 'Método de pagamento',
    align: 'left',
  },
  {
    label: 'Inadimplência',
    align: 'left',
  },
  {
    label: 'Status',
    align: 'left',
  },
];

const DateTime = ({ datetime }) => {
  if (!datetime) { return <></>; }

  const [date, time] = datetime.split(' ');

  return (
    <Box display='flex' flexDirection='column' alignItems='flex-end'>
      <Typography variant='body2'>{date}</Typography>
      <Typography variant='caption'>{time}</Typography>
    </Box>
  );
};

const TableSubscriptions = ({ subscriptions }) => (
  <Table.Container>
    <Table.Head columns={columns} />
    <Table.Body>
      {subscriptions.map((subscription) => (
        <Table.Row key={subscription.id}>
          <Table.Cell align='left'>
            <DateTime datetime={subscription.created_at} />
          </Table.Cell>
          <Table.Cell align='left'>
            <DateTime datetime={subscription.end_at} />
          </Table.Cell>
          <Table.Cell align='left'>
            {subscription.customer_name}
          </Table.Cell>
          <Table.Cell align='left'>
            {subscription.plan_name}
          </Table.Cell>
          <Table.Cell align='left'>
            {subscription.payment_method_name}
          </Table.Cell>
          <Table.Cell align='left'>
            <TagChip {...getPropsTagChipOverdue(subscription.overdue)} />
          </Table.Cell>
          <Table.Cell align='left'>
            <TagChip {...getPropsTagChipStatus(subscription.status)} />
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table.Container>
);

export default TableSubscriptions;
